import React, { memo, useCallback, useMemo, useState } from "react";
import Separator from "../../../../../core/components/Separator.tsx";
import Tag from "../../../../../core/data-display/Tag.tsx";
import { FiltroEmbarqueCompletoEnum } from "../../../../../models/FiltroEmbarqueCompleto.ts";
import "./data-entry-viagens.css";
import SelectInputField, {
	SelectInputOption,
} from "../../../../../core/data-entry/SelectInputField.tsx";
import { useFiltro } from "../../../../../contexts/FiltroContext.tsx";

interface SelectTagProps {
	title: string;
	defaultOptions: SelectInputOption[];
	allOptions: SelectInputOption[];
	filtroKey: FiltroEmbarqueCompletoEnum;
	tags: SelectInputOption[];
	onTagUpdate?: (
		key: FiltroEmbarqueCompletoEnum,
		updatedTags: SelectInputOption[]
	) => void;
	filterOptions?: (
		options: SelectInputOption[],
		inputValue: string
	) => SelectInputOption[];
}

const SelectTag = ({
	title,
	defaultOptions,
	allOptions,
	filtroKey,
	onTagUpdate,
	tags = [],
	filterOptions = (options: SelectInputOption[], inputValue: string) => {
		return options
			.filter(
				(option) =>
					option.title?.toLowerCase().includes(inputValue.toLowerCase()) ||
					option.obj
						?.toString()
						.toLowerCase()
						.includes(inputValue.toLowerCase())
			)
			.slice(0, 100);
	},
}: SelectTagProps) => {
	const { setFiltro } = useFiltro();
	const [selectedOption, setSelectedOption] = useState("");
	const [inputValue, setInputValue] = useState("");

	const handleRemoveTag = useCallback(
		(tagToRemove: { title: string; obj: string }) => {
			const updatedTags = tags.filter((tag) => tag.obj !== tagToRemove.obj);

			setFiltro(
				filtroKey,
				updatedTags.map((tag) => tag.obj)
			);

			onTagUpdate?.(filtroKey, updatedTags);
		},
		[tags, setFiltro, filtroKey, onTagUpdate]
	);

	const onClear = useCallback(() => {
		setSelectedOption("");
		setInputValue("");
	}, []);

	const filteredOptions = useMemo(() => {
		if (inputValue === "") {
			return defaultOptions;
		}
		return filterOptions(allOptions, inputValue);
	}, [allOptions, inputValue, defaultOptions, filterOptions]);

	return (
		<div className="modal-filtros-viagens-select-container">
			<div className="modal-filtros-viagens-select-tag">
				<div className="modal-filtros-viagens-select-button">
					<SelectInputField
						label={title}
						options={filteredOptions || []}
						value={selectedOption}
						onChange={(selected) => {
							if (!tags.some((tag) => tag.obj === selected.obj)) {
								const newTags = [
									...tags,
									{ title: selected.title, obj: selected.obj },
								];
								const ids = newTags.map((tag) => tag.obj);
								setFiltro(filtroKey, ids);
								onTagUpdate?.(filtroKey, newTags);
							}
						}}
						onInputChange={(e) => setInputValue(e.target.value)}
						onClear={onClear}
					/>
				</div>
			</div>
			<Separator size="md" />
			<div className="modal-filtros-viagens-select-tag-list">
				{tags.map((tag, index) => {
					return (
						<Tag
							key={index}
							label={tag.title}
							size="md"
							icon="X"
							onClick={() => handleRemoveTag(tag)}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default memo(SelectTag);
